// Campos padrão para queries de conversa (evita SELECT *)
export const CONVERSATION_FIELDS = `
    id,
    connection_id,
    contact_id,
    remote_jid,
    contact_name,
    avatar_url,
    profile_picture_url,
    last_message,
    last_message_time,
    unread_count,
    status,
    assigned_to,
    tags,
    meta_attribution,
    platform
` as const;

// Tipo para dados brutos do banco
export interface DbConversation {
    id: string;
    connection_id: string;
    contact_id: string | null;
    remote_jid: string;
    contact_name: string | null;
    avatar_url: string | null;
    profile_picture_url: string | null;
    last_message: string | null;
    last_message_time: string | null;
    created_at?: string | null;
    unread_count: number;
    status: string;
    assigned_to: string | null;
    tags: string[] | null;
    meta_attribution: Record<string, unknown> | null;
    platform?: 'whatsapp' | 'instagram' | null;
}

// Tipo para contadores
export interface ConversationCounters {
    unassigned: number;
    mine: number;
    all: number;
}

// Tipo para resultado paginado
export interface PaginatedConversationsResult {
    conversations: import('../../../features/chat/hooks/types').ChatConversation[];
    hasMore: boolean;
    nextCursor?: string;
}

